/**
 * Interface for parsed ECG data
 */
export interface IEcgLeads {
  lead_i: number[]
  lead_ii: number[]
  lead_iii: number[]
  lead_avr: number[]
  lead_avl: number[]
  lead_avf: number[]
  lead_v1: number[]
  lead_v2: number[]
  lead_v3: number[]
  lead_v4: number[]
  lead_v5: number[]
  lead_v6: number[]
}

/**
 * Parses a DAT ECG file and extracts the 12 leads
 * @param file - DAT file to be parsed
 * @returns Promise with the 12 leads data
 */
export const parseEcgDatFile = async (file: File): Promise<IEcgLeads> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = e => {
      try {
        const arrayBuffer = e.target?.result as ArrayBuffer
        const dataView = new DataView(arrayBuffer)

        // Each sample is 2 bytes (i16)
        const totalSamples = arrayBuffer.byteLength / 2

        const numSignals = 12
        const leads: number[][] = Array.from({ length: numSignals }, () => [])

        // Distribute samples among leads in round-robin fashion
        // Sample 0 -> lead 0, Sample 1 -> lead 1, ..., Sample 11 -> lead 11, Sample 12 -> lead 0, ...
        for (let i = 0; i < totalSamples; i++) {
          const byteOffset = i * 2
          if (byteOffset + 2 <= arrayBuffer.byteLength) {
            // Read as i16 little-endian and divide by 1000
            const raw = dataView.getInt16(byteOffset, true)
            leads[i % numSignals].push(raw / 1000)
          }
        }

        console.log('Lead 0 (first 10 values):', leads[0].slice(0, 10))
        console.log('Lead 1 (first 10 values):', leads[1].slice(0, 10))

        const ecgData: IEcgLeads = {
          lead_i: leads[0],
          lead_ii: leads[1],
          lead_iii: leads[2],
          lead_avr: leads[3],
          lead_avl: leads[4],
          lead_avf: leads[5],
          lead_v1: leads[6],
          lead_v2: leads[7],
          lead_v3: leads[8],
          lead_v4: leads[9],
          lead_v5: leads[10],
          lead_v6: leads[11]
        }

        resolve(ecgData)
      } catch (error) {
        console.error('Error parsing DAT file:', error)
        reject(error)
      }
    }

    reader.onerror = () => {
      reject(new Error('Error reading DAT file'))
    }

    // Read as ArrayBuffer (binary) instead of text
    reader.readAsArrayBuffer(file)
  })
}
